/*
  Loop's default delivery frequency in the browser (AJ 2026-10-11 22:37 ET, option A: "ill update loop so its not
  default monthly then just use the default").

  The theme renders each selling plan group on the plan Loop marks as the group's default
  (snippets/cq-preferred-selling-plan.liquid), from a copy of Loop's ids (snippets/cq-loop-defaults.liquid, passed here
  as data-cq-loop-defaults). This script reads Loop's public settings file, the same file Loop's own widget reads, once
  per visit (sessionStorage), with a short timeout and never an error on the page. Only when Loop's default for a group
  differs from the plan the page started on, a picker the shopper has not touched follows Loop: the product page and the
  Configure popup with their replacement cards (assets/cq-option-picker.js, followLoop), Subscribe on a side cart line
  and the side cart's one-tap Adds (assets/cq-cart-drawer.js). While the copy matches Loop, the normal case, nothing
  moves. Whether Subscribe or One-time is preselected is not decided here.

  window.CQLoopDefaults
    load()             Promise of a Set of Loop's default plan ids (strings), or null when the file cannot be read.
    live()             That Set once read, else null.
    snapshot           The theme's copy, a Set of plan ids.
    pick(plans, group, ids)  The plan of `group` that `ids` marks as default, from plans [{id, group}], or null.
    follow(id, plans)  The id to use instead of `id`: Loop's live default in the group of `id` when Loop marks one for
                       these plans, else `id` unchanged.
*/
(() => {
  if (window.CQLoopDefaults) return;
  const script = document.currentScript;
  const toSet = (list) => new Set(list.map((id) => String(id).trim()).filter(Boolean));
  const snapshot = toSet(String(script?.dataset.cqLoopDefaults || '').split(','));
  const file = script?.dataset.cqLoopFile || '';
  const KEY = 'cq-loop-defaults';
  const TIMEOUT = 2500;
  let live = null;
  let pending = null;

  const fromCache = () => {
    try {
      const saved = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (saved && saved.file === file && Array.isArray(saved.ids)) return toSet(saved.ids);
    } catch (error) { /* storage blocked or unreadable: read the file instead */ }
    return null;
  };

  const load = () => {
    if (pending) return pending;
    const cached = fromCache();
    if (cached) {
      live = cached;
      pending = Promise.resolve(live);
      return pending;
    }
    if (!file || !window.fetch) {
      pending = Promise.resolve(null);
      return pending;
    }
    const controller = window.AbortController ? new AbortController() : null;
    const timer = setTimeout(() => controller?.abort(), TIMEOUT);
    pending = fetch(file, { mode: 'cors', credentials: 'omit', signal: controller?.signal })
      .then((response) => (response.ok ? response.json() : null))
      .then((json) => {
        const ids = json?.storeDefaultSellingPlanShopifyIds;
        if (!Array.isArray(ids)) return null;
        live = toSet(ids);
        try { sessionStorage.setItem(KEY, JSON.stringify({ file, ids: [...live] })); } catch (error) { /* private mode */ }
        return live;
      })
      .catch(() => null)
      .finally(() => clearTimeout(timer));
    return pending;
  };

  const pick = (plans, group, ids) => {
    if (!ids || !Array.isArray(plans)) return null;
    return plans.find((plan) => String(plan.group) === String(group) && ids.has(String(plan.id))) || null;
  };

  const follow = (id, plans) => {
    if (!live || !id || !Array.isArray(plans)) return id;
    const current = plans.find((plan) => String(plan.id) === String(id));
    if (!current) return id;
    const target = pick(plans, current.group, live);
    return target ? String(target.id) : id;
  };

  window.CQLoopDefaults = { load, live: () => live, snapshot, pick, follow };
  load();
})();
